/*
 * @Author: shuwen.chen
 * @Email: shuwen.chen@eeoa.com
 * @Date: 2021-08-30 11:54:12
 * @Last Modified by: shuwen.chen
 * @Last Modified time: 2021-09-26 10:36:24
 * @Description: pc navbar组件
 * @Route: Route
 */

<template>
  <div class="header-wrap"
       :class="{
      'header-wrap-position': !isHasPurchase,
      'nav-not-bg': initNavNotBg
    }"
       @mouseenter="mouseenterHandle"
       @mouseleave="mouseleaveHandle">
    <div class="nav-bar-wrap">
      <img src="http://www.hzinfor.cn/uploadFiles/uploadImgs/20230818/c7b3d9816d2c4c0682683e78e6b82419.png"
           alt
           class="nav-icon" />
      <!-- <nuxt-link :to="{name: 'index'}">
        <iconfont :icon-class="initNavNotBg ? 'icon-logo_white' : 'icon-logo_dark'"
                  class-name="nav-icon" />
      </nuxt-link> -->

      <ul class="nav-wrap">
        <li v-for="(item,index) in navList"
            :key="index"
            class="nav-item"
            :class="{
            'nav-not-bg-li': initNavNotBg
          }">
          <p class="nav-wrap-item"
             @click="navHandle(item)"
             :class="{
                'choose-item': $route.name === item.to || (item.routeArr && item.routeArr.indexOf($route.name) > -1),
              }">
            {{ item.name }}
            <span :class="{
                'nav-item-border': $route.name === item.to || (item.routeArr && item.routeArr.indexOf($route.name) > -1),
                'white-nav-item-border':initNavNotBg
              }" />
          </p>
          <secondary v-if="item.list"
                     :list="item.list"
                     :nav-name-obj="item.navNameObj" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Secondary from './secondary-menu-list.vue';

export default {
  name: 'Navbar',
  components: { Secondary },
  data() {
    return {
      isPositionPurchase: false,
      // 退出登录接口
      isWhite: false,
      navList: [
        {
          id: 1,
          name: '首页',
          to: 'home',
        },

        {
          id: 5,
          name: '产品中心',
          navNameObj: {
            name: '产品中心',
            enName: 'Product Center',
          },
          routeArr: ['product', 'hardware', 'download'],
          list: [
            {
              pathName: 'product',
              bgIcon: 'zf',
              id: 1,
            },
            {
              pathName: 'product',
              id: 2,
              bgIcon: 'lc',
            },
            {
              pathName: 'product',
              id: 3,
              bgIcon: 'yp',
            },
            {
              id: 4,
              pathName: 'product',
              bgIcon: 'wj',
            },
            {
              id: 5,
              bgIcon: 'cl',
              pathName: 'product',
            },
            {
              id: 6,
              bgIcon: 'sb',
              pathName: 'product',
            },
            {
              id: 7,
              bgIcon: 'ywzt',
              pathName: 'product',
            },
            {
              id: 8,
              bgIcon: 'yxzpt',
              pathName: 'product',
            },
            {
              id: 9,
              bgIcon: 'iot',
              pathName: 'product',
            },
            {
              id: 10,
              bgIcon: 'ai',
              pathName: 'product',
            },
            {
              id: 11,
              bgIcon: 'cv',
              pathName: 'product',
            },
            {
              id: 12,
              bgIcon: 'order',
              pathName: 'product',
            }
          ],
        },
        {
          id: 5,
          name: '解决方案',
          navNameObj: {
            name: '解决方案',
          },
          routeArr: ['case', 'casedetails'],
          list: [
            {
              bgIcon: 'case-yys',
              name: '运营商',
              pathName: 'case',
              id: 1,
              imgStyle: {
                width: '72px',
                height: '51px',
              },
            },
            {
              bgIcon: 'case-jm',
              name: '军民融合',
              id: 2,
              pathName: 'case',
              imgStyle: {
                width: '23px',
                height: '24px',
              },
            },
            {
              pathName: 'case',
              name: '新零售',
              id: 3,
              bgIcon: 'xls',
              imgStyle: {
                width: '80px',
                height: '53px',
              },
            },
            {
              pathName: 'case',
              name: '医疗',
              id: 4,
              bgIcon: 'case-yiliao',
              imgStyle: {
                width: '72px',
                height: '48px',
                marginTop: '2px',
              },
            },
          ],
        },
        {
          id: 7,
          name: '技术支持',
          to: 'technology',
          navNameObj: {
            name: '关于我们',
            enName: 'About Us',
          },
        },
        // {
        //   id: 7,
        //   name: '关于我们',
        //   to: 'abouts',
        //   navNameObj: {
        //     name: '关于我们',
        //     enName: 'About Us',
        //   },
        // },
      ],
    };
  },
  // computed: {
  //   /**
  //    * @description 顶部导航不固定页面
  //    * @param { object } hasPurchasePage 顶部导航不固定路由name
  //    */
  //   isHasPurchase() {
  //     const { name } = this.$route;
  //     // // 有购买按钮页面name
  //     // const { hasPurchasePage } = config
  //     // if (hasPurchasePage.includes(name)) {
  //     //   return true
  //     // } else {
  //     //   return false
  //     // }
  //   },

  //   /**
  //    * @description 导航默认无背景色
  //    */
  //   initNavNotBg() {
  //     const { name } = this.$route;
  //     // const { initNavNotBgPage } = config;
  //     // if (initNavNotBgPage.includes(name) && !this.isWhite) {
  //     //   return true;
  //     // } else {
  //     //   return false;
  //     // }
  //   },
  // },

  destroyed() {
    document.removeEventListener('scroll', this.handleScroll);
  },
  mounted() {
    document.addEventListener('scroll', (e) => {
      this.handleScroll(e);
    });
  },
  methods: {
    navHandle({ to }) {
      if (!to) return;
      this.$router.push({
        name: to,
      });
    },
    /**
     * @description 购买页面设置购买header固定到顶部
     */
    handleScroll() {
      const scrollY = document.documentElement.scrollTop || document.body.scrollTop;
      // 滚动改变导航颜色
      if (scrollY > 0) {
        this.isWhite = true;
      } else {
        this.isWhite = false;
      }
      const el = document.querySelector('.hardwrare-header-wrap');
      const elz = document.querySelector('.hardwrare-header-z');
      // 固定购买导航
      if (scrollY >= 91) {
        if (el) el.style.position = 'fixed';
        if (elz) elz.style.display = 'block';
      } else {
        this.isPositionPurchase = false;
        if (el) el.style.position = '';
        if (elz) elz.style.display = 'none';
      }
    },
    bgStyle(img) {
      return {
        backgroundImage: `url(${img})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: '100%',
      };
    },
    /**
     * @description 导航无背景色时候 鼠标移入导航颜色边白
     */
    mouseenterHandle() {
      this.isWhite = true;
    },
    /**
     * @description 导航无背景色时候 鼠标移出改变导航颜色
     */
    mouseleaveHandle() {
      const scrollY = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollY === 0) {
        this.isWhite = false;
      } else {
        this.isWhite = true;
      }
    },
    enHandle() {
      // window.location.href = config.classinUrl;
    },
  },
};
</script>
<style lang="scss" scoped>
.header-wrap {
  top: 0;
  right: 0;
  left: 0;
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 1200px;
  height: 80px;
  background: #fff;
  //transition: background-color 1s;
  border-bottom: 1px solid #dcdcdc;

  &-position {
    position: fixed;
  }

  .nav-bar-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 1200px;
    height: 80px;
    padding: 0 10px;

    .nav-icon {
      width: 105px;
      // height: 33px;
    }

    .nav-wrap {
      display: flex;
      align-items: center;
      height: 70px;

      &-item {
        position: relative;
        padding: 8px;
      }

      .nav-item {
        display: flex;
        align-items: center;
        height: 80px;
        //padding: 8px;
        margin: 0 5px;
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-size: 14px;
        font-weight: 500;
        color: #000;
        cursor: pointer;

        // &-border {
        //   position: absolute;
        //   bottom: 0;
        //   left: 0;
        //   width: 100%;
        //   height: 1px;
        //   background: #d8d8d8;
        //   border-bottom: 1px solid #000;
        // }
      }
      .nav-item:hover {
        color: #216bff;
      }
      .nav-not-bg-li {
        color: #fff;
      }
      .choose-item {
        color: #216bff;
      }

      .add-school-btn {
        display: block;
        width: 96px;
        height: 34px;
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-size: 13px;
        font-weight: 500;
        line-height: 34px;
        color: #fff;
        text-align: center;
        background: #00b07a;
        border-radius: 20px;
      }

      .dowload-ClassIn-btn {
        display: block;
        width: 110px;
        height: 34px;
        margin-right: 42px;
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-size: 13px;
        font-weight: 500;
        line-height: 34px;
        color: #fff;
        text-align: center;
        background: #333;
        border-radius: 20px;
      }

      .top_wrap {
        display: flex;
        align-items: center;
        cursor: pointer;

        .login-icon {
          height: 16px;
          margin-right: 8px;
        }

        .lang-icon {
          width: 16px;
          height: 16px;
          margin-right: 6px;
          margin-left: 20px;
        }

        .nav-header-text {
          font-family: PingFangSC-Medium, PingFang SC, sans-serif;
          font-size: 12px;
          font-weight: 500;
          color: #000;
        }
      }
    }
  }

  .log-out {
    display: flex;
    justify-content: center;
    width: 78px;
  }
}

.nav-not-bg {
  background: none;
  border: none;
  transition: background-color 1s;
}

.white-add-school-btn {
  color: #fff !important;
  text-align: center;
  background: none !important;
  border: 1px solid #fff !important;
}

.white-text {
  color: #fff !important;
}

.white-nav-item-border {
  border-bottom: 1px solid #fff !important;
}
</style>
